import type MainQiankun from '@sfvine/main-qiankun'
import type MainWujie from '@sfvine/main-wujie'
import useSettingsStore from '../stores/modules/settings'

type MicroFramework = typeof MainWujie | typeof MainQiankun

const microFramework: { value: MicroFramework | undefined; pending: boolean } = {
  value: undefined,
  pending: false
}

export type WujieOrQiankunSubAppConfig = MainQiankun.QiankunSubAppConfig | MainWujie.SubAppConfig;

/**
 * 根据配置获取微前端框架
 */
export const getWujieOrQiankun = async (): Promise<MicroFramework> => {
  if (microFramework.value) {
    return microFramework.value
  }

  if (microFramework.pending) {
    await new Promise<void>(resolve => {
      document.addEventListener('microFrameworkLoaded', () => {
        resolve()
      })
    })
    return microFramework.value as unknown as MicroFramework
  }

  microFramework.pending = true

  const settingsStore = useSettingsStore()
  if (settingsStore.settings.system.mainAppFramework === 'wujie') {
    microFramework.value = await import('@sfvine/main-wujie')
  } else {
    microFramework.value = await import('@sfvine/main-qiankun')
  }
  
  document.dispatchEvent(new Event('microFrameworkLoaded'))
  return microFramework.value
}
